import { Box, Stack, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { type ExternalAccountLite } from "@src/appV2/redesign/Accounts/PayoutSettings/api/schema";
import { ExternalAccountLogo } from "@src/appV2/redesign/Accounts/PayoutSettings/components/ExternalAccountLogo";
import { CbhIcon, mergeSxProps, Text } from "@src/appV2/redesign/system/ui-components";

export interface ExternalAccountErrorCardProps {
  errorMessage: string;
  externalAccount: ExternalAccountLite;
  sx?: SxProps<Theme>;
}

export function ExternalAccountErrorCard(props: ExternalAccountErrorCardProps) {
  const { errorMessage, externalAccount, sx } = props;

  return (
    <Stack
      direction="row"
      spacing={3}
      sx={mergeSxProps(
        (theme) => ({
          padding: theme.spacing(5),
          borderRadius: theme.spacing(4),
          border: `1px solid ${theme.palette.border?.primary}`,
        }),
        sx
      )}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          width: theme.spacing(6),
          height: theme.spacing(6),
          borderRadius: theme.spacing(6),
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: theme.palette.intent?.error.background,
        })}
      >
        <CbhIcon
          type="triangle-exclamation"
          size="xSmall"
          color={(theme) => theme.palette.intent?.error.icon}
        />
      </Box>
      <Stack spacing={2}>
        <Text semibold variant="body1">
          {errorMessage}
        </Text>
        <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
          <ExternalAccountLogo
            externalAccount={externalAccount}
            iconSize="small"
            sx={(theme) => ({ width: theme.spacing(4), height: theme.spacing(4) })}
          />
          <Text variant="caption" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            {externalAccount.providerName} ···· {externalAccount.last4}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
}
